import React, { useState } from 'react';
import Player from '../Player';
import MIDITest from '../MIDITest';
import SetupInstructions from './SetupInstructions';
import UserGuide from './UserGuide';
import RollingWindowGraph from './RollingWindowGraph';
import SatelliteCourseMap from './SatelliteCourseMap';
import './TabbedInterface.css';

const TabbedInterface = () => {
  const [activeTab, setActiveTab] = useState('player');

  return (
    <div className="tabbed-interface">
      <h1 className="app-title">Data Sonification Engine</h1>
      <div className="tab-header">
        <button
          className={`tab-button ${activeTab === 'guide' ? 'active' : ''}`}
          onClick={() => setActiveTab('guide')}
        >
          📖 User Guide
        </button>
        <button
          className={`tab-button ${activeTab === 'setup' ? 'active' : ''}`}
          onClick={() => setActiveTab('setup')}
        >
          🔌 Midi Setup
        </button>
        <button
          className={`tab-button ${activeTab === 'graph' ? 'active' : ''}`}
          onClick={() => setActiveTab('graph')}
        >
          📈 Live Graph
        </button>
        <button
          className={`tab-button ${activeTab === 'map' ? 'active' : ''}`}
          onClick={() => setActiveTab('map')}
        >
          🌍 Course Map
        </button>
        <button
          className={`tab-button ${activeTab === 'player' ? 'active' : ''}`}
          onClick={() => setActiveTab('player')}
        >
          🎹 Player
        </button>
      </div>
      
      <div className="tab-content">
        <div className={`tab-panel ${activeTab === 'guide' ? 'active' : ''}`}>
          <UserGuide />
        </div>
        <div className={`tab-panel ${activeTab === 'setup' ? 'active' : ''}`}>
          <SetupInstructions />
        </div>
        <div className={`tab-panel ${activeTab === 'graph' ? 'active' : ''}`}>
          <RollingWindowGraph />
        </div>
        <div className={`tab-panel ${activeTab === 'map' ? 'active' : ''}`}>
          <SatelliteCourseMap />
        </div>
        <div className={`tab-panel ${activeTab === 'player' ? 'active' : ''}`}>
          <MIDITest />
          <Player />
        </div>
      </div>
    </div>
  );
};

export default TabbedInterface;

